// Parceiros com integração via API (v1) e os campos de configuração de cada um.
// A lista precisa acompanhar INTEGRATION_PARTNERS do backend: cada parceiro novo exige
// endpoints próprios, então não é cadastrado pela tela.
export const INTEGRATION_PARTNERS = [
  {
    value: 'frigol',
    label: 'Frigol',
    fields: ['company_id', 'operationcenter_id', 'file_type_id'],
  },
  { value: 'compel', label: 'Compel', fields: ['company_id', 'user_id'] },
]

export const CONFIG_FIELD_LABELS = {
  company_id: 'Empresa',
  operationcenter_id: 'Central de operações',
  file_type_id: 'Tipo de arquivo do ciclo',
  user_id: 'Usuário autor dos eventos',
}

export function partnerLabel(partner) {
  const found = INTEGRATION_PARTNERS.find(p => p.value === partner)
  return found ? found.label : partner
}
